// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18sxN","footer":"styles_footer__1BF_K","passCodeTooltip":"styles_passCodeTooltip__199Wx"};